import PropTypes from "prop-types";
import React, { useState } from "react";
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Input,
  Label,
} from "reactstrap";

// Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Icons (Skote uses Remix/Iconify – using simple icons)
import { withTranslation } from "react-i18next";

const TeamsGrid = props => {
  document.title = "Admin | Teams";

  // ================= STATE =================
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);

  const [teams, setTeams] = useState([
    {
      id: 1,
      name: "Support Team",
      lead: "John Smith",
      members: 5,
      image: "https://ui-avatars.com/api/?name=Support+Team&background=556ee6&color=fff",
    },
    {
      id: 2,
      name: "Sales Team",
      lead: "Sarah Lee",
      members: 8,
      image: "https://ui-avatars.com/api/?name=Sales+Team&background=34c38f&color=fff",
    },
    {
      id: 3,
      name: "Marketing Team",
      lead: "David Miller",
      members: 6,
      image: "https://ui-avatars.com/api/?name=Marketing+Team&background=f1b44c&color=fff",
    },
  ]);

  const [form, setForm] = useState({
    name: "",
    lead: "",
    image: null,
    preview: null,
  });

  // ================= HANDLERS =================
  const toggleOffcanvas = () =>
    setIsOffcanvasOpen(!isOffcanvasOpen);

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (!file) return;

    setForm({
      ...form,
      image: file,
      preview: URL.createObjectURL(file),
    });
  };

  const addTeam = () => {
    if (!form.name || !form.lead) return;

    setTeams([
      ...teams,
      {
        id: teams.length + 1,
        name: form.name,
        lead: form.lead,
        members: 0,
        image:
          form.preview ||
          `https://ui-avatars.com/api/?name=${encodeURIComponent(
            form.name
          )}&background=6f42c1&color=fff`,
      },
    ]);

    setForm({ name: "", lead: "", image: null, preview: null });
    toggleOffcanvas();
  };

  // ================= UI =================
  return (
    <div className="page-content">
      <Container fluid>

        <Breadcrumbs
          title={props.t("Settings")}
          breadcrumbItem={props.t("Teams")}
        />

        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0"></h4>
          <Button color="primary" onClick={toggleOffcanvas}>
            + Add Team
          </Button>
        </div>

        {/* ================= GRID ================= */}
        <Row>
          {teams.map(team => (
            <Col xl="3" md="4" sm="6" key={team.id}>
              <Card className="text-center">
                <CardBody>
                  <div className="mb-3">
                    <img
                      src={team.image}
                      alt={team.name}
                      className="rounded-circle avatar-lg"
                    />
                  </div>

                  <h5 className="font-size-15 mb-1">
                    {team.name}
                  </h5>
                  <p className="text-muted mb-2">
                    Lead: {team.lead}
                  </p>

                  <div className="d-flex justify-content-center gap-2 mb-3">
                    <span className="badge bg-soft-primary text-primary">
                      {team.members} Members
                    </span>
                  </div>

                  {/* ACTIONS */}
                  <div className="d-flex justify-content-center gap-3 text-muted">
                    <i className="bx bx-message-rounded-dots font-size-18" />
                    <i className="bx bx-user font-size-18" />
                    <i className="bx bx-cog font-size-18" />
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        {/* ================= OFFCANVAS ================= */}
        <Offcanvas
          isOpen={isOffcanvasOpen}
          toggle={toggleOffcanvas}
          direction="end"
        >
          <OffcanvasHeader toggle={toggleOffcanvas}>
            Add Team
          </OffcanvasHeader>

          <OffcanvasBody>
            <div className="text-center mb-4">
              {form.preview ? (
                <img
                  src={form.preview}
                  alt="Preview"
                  className="rounded-circle avatar-xl mb-2"
                />
              ) : (
                <div className="avatar-xl bg-light rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2">
                  <i className="bx bx-image font-size-24 text-muted" />
                </div>
              )}
              <Input type="file" accept="image/*" onChange={handleImageChange} />
            </div>

            <div className="mb-3">
              <Label>Team Name</Label>
              <Input
                name="name"
                value={form.name}
                onChange={handleChange}
              />
            </div>

            <div className="mb-4">
              <Label>Team Lead</Label>
              <Input
                name="lead"
                value={form.lead}
                onChange={handleChange}
              />
            </div>

            <div className="text-end">
              <Button
                color="secondary"
                className="me-2"
                onClick={toggleOffcanvas}
              >
                Cancel
              </Button>
              <Button color="primary" onClick={addTeam}>
                Save Team
              </Button>
            </div>
          </OffcanvasBody>
        </Offcanvas>

      </Container>
    </div>
  );
};

TeamsGrid.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(TeamsGrid);
